import HandMoneyImage from '@/images/icon-hand-money.svg'
import SignPostImage from '@/images/icon-signposts.svg'
import UpgradeImage from '@/images/icon-upgrade.svg'
import {EnquiryForm} from '@/scripts/components/enquiry-form'
import {default_enquiry_fields, utm_hidden_fields} from '@/scripts/util/enquiry-form-fields'
import {
    findLineItemsProductTitle,
    findLineItemsSKU,
    findLineItemsTagValue,
    findLineItemsURL,
    findProductSku,
    findTag
} from "@/scripts/util/getProductData"
import {getSalesforceEndpoints} from '@/scripts/util/getSalesforceEndpoints'
import $ from 'jquery'
import {register} from '@shopify/theme-sections'
import React from "react"
import {createRoot} from "react-dom/client"
import {formatCurrencyByLocale} from '../util/formatCurrencyByLocale'
import {GQL_END_POINT} from '@/scripts/configs/store'
import {stateLabel, stateOptions} from '@/scripts/util/country-fields'
import {formatMoney} from "@shopify/theme-currency"

export default register(`template-cart`, {
    onLoad() {
        /**
         * New WeRD Cart Functionality
         * Set the Cookie once the Form has been submitted
         * ===> Cookies.set("_rent_submit", "1", { expires: 1 });
         */

        /**
         * set GA Object
         */
        const GA_OBJECT = {}

        // start...
        const $popup = document.querySelectorAll(`[data-trigger="popup"]`)
        // finish...
        const endpoint = GQL_END_POINT
        const cartItemIds = []
        const cartItemProducts = document.querySelectorAll(`[data-cart-item-id]`)
        const cart = document.querySelector(`[data-section-id='template-cart']`)

        // Only appears on AU currently, will be undefined otherwise.
        const financePurchaseTypeButton = document.querySelector(`#finance_toggle_button`)
        const financeCartForm = document.querySelector(`#finance_checkout_form`)

        const creditCardPurchaseTypeButton = document.querySelector(`#credit_card_toggle_button`)
        const enquiryPurchaseTypeButton = document.querySelector(`#enquiry_toggle_button`)

        const creditCardCartForm = document.querySelector(`#credit_card_checkout_form`)
        const enquiryCartForm = document.querySelector(`#enquiry_checkout_form`)

        // Rent-Try-Buy & Lease-To-Keep
        const rtb_rental_option = document.querySelector(`#rtb_rental_option`)
        const ltk_rental_option = document.querySelector(`#ltk_rental_option`)

        const cartItemJsonData = document.getElementById(`cartItemJson`) ?
            JSON.parse(document.getElementById(`cartItemJson`).innerHTML) :
            []

        const products = cartItemJsonData.map(item => {
            return {
                ...item.product,
                meta: item.meta
            }
        })
        cart.classList.add(`visible`)

        /**
         * Helper Function to check if the cart is empty
         * @returns - boolean
         */
        const isCartEmpty = () => {
            return Array.isArray(cartItemIds) && !cartItemIds.length
        }
        

        /**
         * Loop over the Cart Item Product IDs and push to array
         */
        for (const cartItem of cartItemProducts) {
            const productId = cartItem.dataset.cartItemId
            cartItemIds.push(btoa(`gid://shopify/Product/${productId}`))
        }

        const setRentTryBuyValue = products => {
            /**
             * Staging AU will return a value for this that's off by a factor of 100. Staging AU uses a MONEY metafield
             * type but all other stores have used a DECIMAL type value. So they all need to be multiplied by 100 to get
             * it to the format that's expected, but Staging AU wouldn't.
             *
             * To fix this we'd ideally need to fix the staging au metafields to be DECIMAL instead of MONEY
             */
            const totalWeeklyRentalPrice = products.reduce(
                (accumulator, currentValue) => {
                    const price = currentValue.meta?.weeklyrental ?? Math.round(currentValue.price * 0.055 * 12 / 52)
                    return accumulator + +price
                },
                0
            )

            const formattedPrice = `${formatCurrencyByLocale({
                amount: totalWeeklyRentalPrice * 100, format: window.theme.moneyFormat
            })}/wk`

            const formattedTotalPrice = `${formatCurrencyByLocale({
                amount: totalWeeklyRentalPrice * 52 * 100, format: window.theme.moneyFormat
            })}`
            
            const priceHtml = totalWeeklyRentalPrice > 0 ? formattedPrice : `N/A`
            $(`[data-total-rent-price]`).html(priceHtml)
            $(`[data-total-rent-try-buy]`).html(priceHtml)

            GA_OBJECT.rentalTotalAmount = `${formatCurrencyByLocale({
                amount: totalWeeklyRentalPrice * 100, format: window.theme.moneyFormat
            })}`
        }

        /**
         * PMTFunction is a function used within financial formulas
         * Resource: https://corporatefinanceinstitute.com/resources/excel/functions/pmt-function/#:~:text=The%20PMT%20function%20uses%20the,future%20payments%20is%20worth%20now
         */
        function PMTFunction(rate, nperiod, pv, fv, type) {
            if (!fv) fv = 0
            if (!type) type = 0

            if (rate === 0) return -(pv + fv) / nperiod

            let pvif = Math.pow(1 + rate, nperiod)
            let pmt = (rate / (pvif - 1)) * -(pv * pvif + fv)

            if (type == 1) {
                pmt /= 1 + rate
            }

            return pmt
        }

        const setLeaseToKeepValue = products => {
            // Going off the Equipment Costs (Sub Totals)
            let subTotalCartPrice = document.querySelector(`[data-sub-total]`)
            subTotalCartPrice = subTotalCartPrice && subTotalCartPrice.dataset && subTotalCartPrice.dataset.subTotal

            const totalLeaseToKeepPrice = getLeaseToKeepProductPrice(subTotalCartPrice)
            const formattedPrice = `${formatCurrencyByLocale({
                amount: totalLeaseToKeepPrice, format: window.theme.moneyFormat
            })}/mth`

            const formattedTotalPrice = `${formatCurrencyByLocale({
                amount: totalLeaseToKeepPrice * 48, format: window.theme.moneyFormat
            })}`

            $(`[data-total-lease-price]`).html(totalLeaseToKeepPrice > 0 ? formattedPrice : `N/A`)

            $(`[data-total-lease-to-keep]`).html(totalLeaseToKeepPrice > 0 ? formattedTotalPrice : `N/A`)

            /**
             * Set the GA Object
             * subTotalCartPrice -
             */
            const gaSubTotalCartPrice = `${formatCurrencyByLocale({
                amount: subTotalCartPrice, format: window.theme.moneyFormat
            })}`
            GA_OBJECT.subTotalCartPrice = gaSubTotalCartPrice
        }

        /**
         * Get the Produce Price
         * @param {object} product
         * @returns - the Purchase Price object for the product
         */
        const getProductPurchasePrice = product => {
    
            const {price, compare_at_price} = product
            return {
                amount: price, salePrice: compare_at_price
            }
        }


        /**
         * Get the Lease To Keep Produce Price
         * @param {object} product - Takes in the Product GraphQl response
         * @param value
         * @returns - the calculated Weekly Lease To Keep Price
         */
        const getLeaseToKeepProductPrice = ( value) => {
            const term = 4 // 4 years or 5 years
            const numOfTermMonth = term * 12
            const monthlyValue = PMTFunction(21 / 1200, numOfTermMonth, -1 * value, 0, 1)
            return monthlyValue ? monthlyValue : null
        }

        setRentTryBuyValue(products)
        setLeaseToKeepValue(products)
        /**
         * Make the Graph QL API to collect the
         * Metafield Data for Weekly Prices
         */
        GA_OBJECT.productsArray = products
        fireGAevent()
        
        /**
         * Scroll to the top of the window
         */
        const scrollToTop = () => {
            // There is a CSS rule that puts the height of the
            // '.body-wrapper' to 100vh and overflow scroll.
            // Which effects the scroll event on mobile
            let dist = 0
            if (window.innerWidth > 760) {
                window.scroll({
                    top: dist, behavior: `smooth`
                })
            } else {
                dist = document.querySelector(`.cart-template__continue-shopping`).offsetTop
                window.scroll({
                    top: dist, behavior: `smooth`
                })
            }
        }
        /**
         * Toggle the Purchase Types
         */
        const activateEnquiryCheckoutOption = () => {
            // Fade In Enquiry Form
            financeCartForm && financeCartForm.classList.add(`hide`)
            creditCardCartForm && creditCardCartForm.classList.add(`hide`)
            enquiryCartForm && enquiryCartForm.classList.remove(`hide`)

            setTimeout(() => {
                financePurchaseTypeButton && financePurchaseTypeButton.classList.remove(`active`)
                financeCartForm && financeCartForm.classList.remove(`active`)

                creditCardPurchaseTypeButton && creditCardPurchaseTypeButton.classList.remove(`active`)
                creditCardCartForm && creditCardCartForm.classList.remove(`active`)

                enquiryPurchaseTypeButton && enquiryPurchaseTypeButton.classList.add(`active`)
                enquiryCartForm && enquiryCartForm.classList.add(`active`)
            }, 80)
            window.sessionStorage.setItem(`silverchef_checkout_type`, `enquiry`)
        }
        const activateCreditCardCheckoutOption = () => {
            // Fade In Credit Card Form
            financeCartForm && financeCartForm.classList.add(`hide`)
            creditCardCartForm && creditCardCartForm.classList.remove(`hide`)
            enquiryCartForm && enquiryCartForm.classList.add(`hide`)

            setTimeout(() => {
                financePurchaseTypeButton && financePurchaseTypeButton.classList.remove(`active`)
                financeCartForm && financeCartForm.classList.remove(`active`)

                creditCardPurchaseTypeButton && creditCardPurchaseTypeButton.classList.add(`active`)
                creditCardCartForm && creditCardCartForm.classList.add(`active`)

                enquiryPurchaseTypeButton && enquiryPurchaseTypeButton.classList.remove(`active`)
                enquiryCartForm && enquiryCartForm.classList.remove(`active`)
            }, 80)
            window.sessionStorage.setItem(`silverchef_checkout_type`, `credit_card`)
        }

        const activateFinanceCheckoutOption = () => {
            // Fade In Credit Card Form
            // Don't need AU check here, as this is only used for AU
            financeCartForm && financeCartForm.classList.remove(`hide`)
            creditCardCartForm && creditCardCartForm.classList.add(`hide`)
            enquiryCartForm && enquiryCartForm.classList.add(`hide`)

            setTimeout(() => {
                financePurchaseTypeButton && financePurchaseTypeButton.classList.add(`active`)
                financeCartForm && financeCartForm.classList.add(`active`)

                creditCardPurchaseTypeButton && creditCardPurchaseTypeButton.classList.remove(`active`)
                creditCardCartForm && creditCardCartForm.classList.remove(`active`)

                enquiryPurchaseTypeButton && enquiryPurchaseTypeButton.classList.remove(`active`)
                enquiryCartForm && enquiryCartForm.classList.remove(`active`)
            }, 80)
            window.sessionStorage.setItem(`silverchef_checkout_type`, `finance`)
        }
        const togglePurchaseType = (self, buttonId) => {
            scrollToTop()
            if (self.id === buttonId && !self.classList.contains(`disabled`)) {
                activateEnquiryCheckoutOption()
            } else if (self.id === `finance_toggle_button`) {
                activateFinanceCheckoutOption()
            } else {
                activateCreditCardCheckoutOption()
            }
        }

        financePurchaseTypeButton && financePurchaseTypeButton.addEventListener(`click`, function () {
            togglePurchaseType(this, ``)
        })
        creditCardPurchaseTypeButton && creditCardPurchaseTypeButton.addEventListener(`click`, function () {
            togglePurchaseType(this, ``)
        })
        enquiryPurchaseTypeButton && enquiryPurchaseTypeButton.addEventListener(`click`, function () {
            togglePurchaseType(this, `enquiry_toggle_button`)
        })

        /**
         * Determine Checkout Type
         */
        const determineCheckoutType = () => {
            if (!isCartEmpty()) {
                const type = window.sessionStorage.getItem(`silverchef_checkout_type`)
                if (type === `finance` || (!type)) {
                    activateFinanceCheckoutOption()
                } else if (type === `enquiry`) {
                    activateEnquiryCheckoutOption()
                } else {
                    activateCreditCardCheckoutOption()
                }
            }
        }
        document.addEventListener(`DOMContentLoaded`, determineCheckoutType)
        
        
        
        /*
         * Enquiry Form (RTB to follow)
         */
        // New Enquiry Form, REACT component
        const {action_rental_form, action_rental_finance_form} = getSalesforceEndpoints()
        
        // Hidden fields are the same for "RTB" and "Enquiry" forms.
        if (products.length) {
            const totalWeeklyRental = products.reduce((accumulator, currentValue) => {
                return accumulator + +currentValue.meta.rentalprice
            }, 0)
            const totalFinanceAmount = products.reduce((accumulator, currentValue) => {
                return accumulator + +currentValue.price
            }, 0)
            const cartHiddenFields = [
                {
                    name: `asset_category`,
                    value: findLineItemsTagValue(products, `cat:`)
                },
                {
                    name: `asset_sub_category`,
                    value: findLineItemsTagValue(products, `subcat:`)
                },
                {
                    name: `asset_number`,
                    value: findLineItemsSKU(products)
                },
                {
                    name: `asset_name`,
                    value: findLineItemsProductTitle(products)
                },
                {
                    name: `asset_link`,
                    value: findLineItemsURL(products)
                },
                {
                    name: `total_weekly_rental`,
                    value: totalWeeklyRental
                },
                {
                    name: `lead_category`,
                    value: `Used Equipment`
                },
                {
                    name: `lead_sub_category`,
                    value: `Product Enquiry`,
                },
                ...utm_hidden_fields
            ]

            const enquiryFormHeader = `Got a question about ${products.length === 1 ? `this ${products[0].title}` : `these items?`}`

            const enquiryFormRoot = createRoot(document.getElementById(`cart-enquiry-button`))
            const submitEvents = () => {
                window.dataLayer = window.dataLayer || []
                let eventObject = {
                    event: `rentalenquiryapplicationsuccess`,
                    dealer: ``,
                    products: products.map(product => {
                        return {
                            equipmentName: product.title,
                            equipmentCategory: findTag(product.tags, `cat:`, true),
                            equipmentRefNo: findProductSku(product.variants)
                        }
                    }),
                    totalEquipmentFinance: `${formatMoney(totalFinanceAmount, window.theme.moneyFormat)}`,
                    weeklyRent: totalWeeklyRental ? `${formatMoney(totalWeeklyRental, window.theme.moneyFormat)}` : ``,
                    promoCode: ``,
                }
                const GA_OBJECT = {...eventObject}
                window.dataLayer.push(GA_OBJECT)
            }
            const enquirySubmitEvents = async () => {
                submitEvents()
                await fetch(
                    `/cart/clear.js`,
                    {
                        method: `POST`
                    }
                )
            }
            enquiryFormRoot.render(
                <EnquiryForm
                    buttonClassName={`button is-primary is-large wide margin-top-2x margin-bottom-2x`}
                    openButtonText={`Enquire Now`}
                    header={enquiryFormHeader}
                    fields={default_enquiry_fields}
                    hiddenFields={cartHiddenFields}
                    formId={`product-enquiry`}
                    actionUri={action_rental_form}
                    content={{
                        message: `Fill out the quick form and we'll get back to you within <strong>1 business day</strong>`,
                        icons: [
                            {
                                image: SignPostImage,
                                text: `<strong>Flexible</strong>, 12 month rental agreement`
                            },
                            {
                                image: HandMoneyImage,
                                text: `Rental payments are <strong>100% tax deductible</strong>`
                            },
                            {
                                image: UpgradeImage,
                                text: `Upgrade or buy the equipment <strong>at any time</strong>`
                            }
                        ]
                    }}
                    submitEvents={enquirySubmitEvents}
                />
            )

            const financeFormHeader = `Need finance for ${products.length === 1 ? `this ${products[0].title}` : `these items?`}`
            const financeFormFields = [
                [
                    {
                        name: `first_name`,
                        label: `First Name`,
                        required: true
                    },
                    {
                        name: `last_name`,
                        label: `Last Name`,
                        required: true
                    },
                ],
                {
                    name: `email`,
                    label: `Email`,
                    type: `email`,
                    required: true,
                },
                {
                    name: `phone`,
                    label: `Mobile Phone`,
                    type: `tel`,
                    required: true,
                },
                [
                    {
                        name: `state`,
                        label: stateLabel(),
                        type: `select`,
                        options: stateOptions(),
                        required: true
                    },
                    {
                        name: `trading_name`,
                        label: `Trading Name`
                    }
                ],
                {
                    name: `note`,
                    label: `Note`,
                    type: `textarea`,
                    required: false,
                }
            ]
            const financeFormRoot = createRoot(document.getElementById(`cart-finance-button`))
            financeFormRoot.render(
                <EnquiryForm
                    buttonClassName={`button is-primary is-large wide margin-top-2x margin-bottom-2x`}
                    openButtonText={`Get started`}
                    header={financeFormHeader}
                    fields={financeFormFields}
                    hiddenFields={cartHiddenFields}
                    formId={`product-enquiry`}
                    actionUri={action_rental_finance_form}
                    content={{
                        message: `Fill out the quick form and we'll get back to you within <strong>1 business day</strong>`,
                        icons: [
                            {
                                image: SignPostImage,
                                text: `<strong>Flexible</strong>, 12 month rental agreement`
                            },
                            {
                                image: HandMoneyImage,
                                text: `Rental payments are <strong>100% tax deductible</strong>`
                            },
                            {
                                image: UpgradeImage,
                                text: `Upgrade or buy the equipment <strong>at any time</strong>`
                            }
                        ]
                    }}
                    submitEvents={submitEvents}
                />
            )
        }
        

        /**
         * Google analytics - Original
         */
        function fireGAevent() {
            const findProductSku = variants => {
                const sku = variants && variants.edges && variants.edges[0].node && variants.edges[0].node.sku
                return sku ? sku : null
            }

            const findTag = (tags, keyWord, trimKeyword = false) => {
                const tag = tags && tags.find(tag => tag.includes(`${keyWord}`))
                if (trimKeyword) {
                    return tag ? tag.replace(`${keyWord}`, ``) : null
                } else {
                    return tag ? tag : null
                }
            }

            const dataLayerObject = {
                event: `transaction1.0viewcart`,
                weeklyRent: GA_OBJECT.rentalTotalAmount,
                totalEquipmentFinance: GA_OBJECT.subTotalCartPrice,
                products: GA_OBJECT.productsArray.map(product => ({
                    equipmentName: product && product.title,
                    equipmentCategory: product && findTag(product.tags, `cat:`, true),
                    equipmentRefNo: product && findProductSku(product.variants)
                }))
            }

            window.dataLayer.push(dataLayerObject)
        }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload() {
    }
})
